module.exports = __webpack_public_path__ + "img/arrow-down-1.1df16087.svg";